import React, { useState } from 'react';

const ChatInput = ({ sendMessage }) => {
    const [message, setMessage] = useState('');
    const MAX_MESSAGE_LENGTH = 300;

    const handleSend = () => {
        if (!message.trim()) return;
        if (message.length > MAX_MESSAGE_LENGTH) {
            alert(`메시지는 최대 ${MAX_MESSAGE_LENGTH}자까지 입력 가능합니다.`);
            return;
        }
        sendMessage(message);
        setMessage('');
    };

    return (
        <div className="flex flex-col mt-2 w-full">
            <div className="flex">
                <input
                    className="border p-2 text-black font-semibold flex-1 rounded"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleSend()}
                    placeholder="Enter message"
                    maxLength={MAX_MESSAGE_LENGTH}
                />
                <button
                    onClick={handleSend}
                    className="ml-2 bg-blue-500 text-white px-4 rounded"
                >
                    Send
                </button>
            </div>
            <p className="text-sm text-gray-500 text-right mt-1">
                {message.length} / {MAX_MESSAGE_LENGTH}자
            </p>
        </div>
    );
};

export default ChatInput;
